import { useState } from 'react';
import { FaCalculator } from 'react-icons/fa';
import './LoanCalculation.css';

const EMICalculator = () => {
  const [inputs, setInputs] = useState({
    amount: 1000000,
    rate: 9.5,
    tenure: 5,
    tenureType: 'years'
  });

  const [results, setResults] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs(prev => ({
      ...prev,
      [name]: value
    }));
  };

/*  const calculateEMI = () => {
    const principal = parseFloat(inputs.amount);
    const annualRate = parseFloat(inputs.rate);
    let months = parseInt(inputs.tenure);

    if (inputs.tenureType === 'years') {
      months = months * 12;
    }

    if (!principal || principal <= 0 || !annualRate || annualRate < 0 || !months || months <= 0) {
      alert('Please enter valid values');
      return;
    }

    const monthlyRate = annualRate / 12 / 100;

    let emi;
    if (monthlyRate === 0) {
      emi = Math.round(principal / months);
    } else {
      const onePlusR = 1 + monthlyRate;
      const onePlusRPowerN = Math.pow(onePlusR, months);
      emi = Math.round((principal * monthlyRate * onePlusRPowerN) / (onePlusRPowerN - 1));
    }

    const totalPayment = emi * months;
    const totalInterest = totalPayment - principal;

    setResults({
      emi,
      totalPayment,
      totalInterest,
      months,
      years: (months / 12).toFixed(1),
      monthlyInterest: Math.round(totalInterest / months)
    });
  };*/
  const calculateEMI = () => {
  const principal = parseFloat(inputs.amount);
  const annualRate = parseFloat(inputs.rate);
  let months = parseInt(inputs.tenure);

  if (inputs.tenureType === 'years') {
    months = months * 12;
  }

  if (!principal || principal <= 0 || !annualRate || annualRate < 0 || !months || months <= 0) {
    alert('Please enter valid values');
    return;
  }

  const monthlyRate = annualRate / 12 / 100;

  let exactEMI;

  if (monthlyRate === 0) {
    exactEMI = principal / months;
  } else {
    const onePlusR = 1 + monthlyRate;
    const onePlusRPowerN = Math.pow(onePlusR, months);

    exactEMI =
      (principal * monthlyRate * onePlusRPowerN) /
      (onePlusRPowerN - 1);
  }

  // ✅ USE exact EMI for calculations
  const totalPayment = exactEMI * months;
  const totalInterest = totalPayment - principal;

  // ✅ ONLY round for display
  const emi = Math.round(exactEMI);

  setResults({
    emi,
    totalPayment: Math.round(totalPayment),
    totalInterest: Math.round(totalInterest),
    months,
    years: (months / 12).toFixed(1),
    monthlyInterest: Math.round(totalInterest / months)
  });
};

  const resetCalculator = () => {
    setInputs({
      amount: 1000000,
      rate: 9.5,
      tenure: 5,
      tenureType: 'years'
    });
    setResults(null);
  };

  return (
    <div className="emi-calculator-container form-container">
      <h2><FaCalculator className="header-icon" /> EMI Calculator</h2>
      <p className="calculator-description">
        Calculate your monthly EMI for any loan amount, interest rate, and tenure
      </p>

      <form onSubmit={(e) => { e.preventDefault(); calculateEMI(); }}>
        {/* Loan Amount */}
        <div className="input-group">
          <label>Loan Amount (₹):</label>
          <input
            type="number"
            name="amount"
            value={inputs.amount}
            onChange={handleChange}
            required
            min="10000"
            step="10000"
          />
          <small className="amount-helper">₹ {parseInt(inputs.amount).toLocaleString('en-IN')}</small>
        </div>

        {/* Interest Rate */}
        <div className="input-group">
          <label>Annual Interest Rate (%):</label>
          <input
            type="number"
            name="rate"
            value={inputs.rate}
            onChange={handleChange}
            required
            min="0"
            max="50"
            step="0.1"
          />
        </div>

        {/* Tenure */}
        <div className="tenure-group">
          <div className="input-half">
            <label>Tenure:</label>
            <input
              type="number"
              name="tenure"
              value={inputs.tenure}
              onChange={handleChange}
              required
              min="1"
            />
          </div>
          <div className="input-half">
            <label>Period:</label>
            <select
              name="tenureType"
              value={inputs.tenureType}
              onChange={handleChange}
            >
              <option value="years">Years</option>
              <option value="months">Months</option>
            </select>
          </div>
        </div>

        {/* Buttons */}
        <div className="button-group">
          <button type="submit" className="calculate-btn">
            Calculate EMI
          </button>
          <button
            type="button"
            onClick={resetCalculator}
            className="reset-btn"
          >
            Reset
          </button>
        </div>
      </form>

      {/* Results */}
      {results && (
        <div className="results-container">
          <h3 className="results-header">EMI Calculation Results</h3>

          <div className="results-grid">
            <div className="result-card emi-card">
              <p className="result-label">Monthly EMI</p>
              <p className="result-value emi-value">
                ₹ {results.emi.toLocaleString('en-IN')}
              </p>
            </div>

            <div className="result-card interest-card">
              <p className="result-label">Total Interest</p>
              <p className="result-value interest-value">
                ₹ {results.totalInterest.toLocaleString('en-IN')}
              </p>
            </div>

            <div className="result-card tenure-card">
              <p className="result-label">Tenure</p>
              <p className="result-value tenure-value">
                {results.years} Yrs
              </p>
            </div>

            <div className="result-card total-card">
              <p className="result-label">Total Payment</p>
              <p className="result-value total-value">
                ₹ {results.totalPayment.toLocaleString('en-IN')}
              </p>
            </div>
          </div>

          {/* Breakdown Table */}
          <div className="table-responsive">
            <table className="breakdown-table">
              <tbody>
                <tr>
                  <td>Loan Amount</td>
                  <td className="text-right">
                    ₹ {parseInt(inputs.amount).toLocaleString('en-IN')}
                  </td>
                </tr>
                <tr>
                  <td>Interest Rate</td>
                  <td className="text-right">
                    {inputs.rate}% p.a.
                  </td>
                </tr>
                <tr>
                  <td>Tenure</td>
                  <td className="text-right">
                    {results.months} Months
                  </td>
                </tr>
                <tr className="highlight-row-blue">
                  <td>Monthly EMI</td>
                  <td className="text-right bold-blue">
                    ₹ {results.emi.toLocaleString('en-IN')}
                  </td>
                </tr>
                <tr>
                  <td>Total Interest Payable</td>
                  <td className="text-right">
                    ₹ {results.totalInterest.toLocaleString('en-IN')}
                  </td>
                </tr>
                <tr className="highlight-row-orange">
                  <td>Total Amount Payable</td>
                  <td className="text-right bold-orange">
                    ₹ {results.totalPayment.toLocaleString('en-IN')}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );

};

export default EMICalculator;
